import { render, staticRenderFns } from "./RoomsLayout.vue?vue&type=template&id=67b04a6c"
import script from "./RoomsLayout.vue?vue&type=script&lang=ts"
export * from "./RoomsLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports